module.exports = "/_next/static/images/sebastian-martinez@3x-aa34fc76113a29945c108d4729f88b37.png";